<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4" v-show="showOnly !== true">
        <el-input placeholder="姓名" v-model="username"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="手机号" v-model="mobile"></el-input>
      </el-col>
      <el-col :span="14">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2" v-show="showOnly !== true">
        <router-link to="./icAdd">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col>
    </el-row>

    <el-table
      :data="data"
      border
      stripe
      style="width: 100;"
      v-show="showOnly !== true"
    >
      <el-table-column prop="username" label="姓名"> </el-table-column>

      <el-table-column prop="mobile" label="手机号"> </el-table-column>
      <!-- <el-table-column prop="mail" label="email">
            </el-table-column>
            <el-table-column prop="wechat" label="微信号">
            </el-table-column>
            <el-table-column prop="institution.name" label="机构">
            </el-table-column>
            <el-table-column prop="institution.address" label="机构地址">
            </el-table-column>
            <el-table-column prop="devNum" label="设备数量">
            </el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <router-link :to="'./bind/'+scope.row.id">
                        <el-button type="text" size="small">绑定机构</el-button>
                    </router-link>
                </template>
            </el-table-column> -->
    </el-table>
    <el-table
      :data="data"
      border
      stripe
      style="width: 100;"
      v-show="showOnly === true"
      highlight-current-row
      @current-change="handleUserChange"
    >
    <el-table-column
      >
      <template  slot-scope="scope">
        
        <el-radio v-model="radio" :label="scope.row.id">{{scope.row.mobile}}</el-radio>
      </template>
    </el-table-column>
      <!-- <el-table-column prop="mobile" label="手机号"> </el-table-column> -->
      <!-- <el-table-column prop="mail" label="email">
            </el-table-column>
            <el-table-column prop="wechat" label="微信号">
            </el-table-column>
            <el-table-column prop="institution.name" label="机构">
            </el-table-column>
            <el-table-column prop="institution.address" label="机构地址">
            </el-table-column>
            <el-table-column prop="devNum" label="设备数量">
            </el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <router-link :to="'./bind/'+scope.row.id">
                        <el-button type="text" size="small">绑定机构</el-button>
                    </router-link>
                </template>
            </el-table-column> -->
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "individualCustomers",
  props: {
    showOnly: Boolean,
    handleUserChange: Function,
  },
  data() {
    return {
      radio:"",
      username: "",
      mobile: "",
      institutionName: "",
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },

    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        userType: 1,
      };
      if (this.username.trim() != "") {
        params.username = this.username;
      }
      if (this.mobile.trim() != "") {
        params.mobile = this.mobile;
      }
      if (this.institutionName.trim() != "") {
        params.institutionName = this.institutionName;
      }

      this.$http.post("/manage/customer/list", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
  },
  components: { Pagination },
};
</script>
